module.exports = __webpack_public_path__ + "static/img/goodsclassifyA.72f51a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/goodsclassifyA.jpg
// module id = cUmc
// module chunks = 31